import { CitizenshipStatusEnum } from '@interfaces/open-account/enums';
import { Action, createReducer, on } from '@ngrx/store';
import { IDPSResponse, IDPSState, YesNoEmpty } from '@shared/models';

import * as PersonalDataActions from '../../actions/personal-data/personal-data.actions';
import { MfePersonalInfoClientState } from '../mfe-personal-info-client/mfe-personal-info-client.reducer';
import {
  CITIZENSHIP_NONRESIDENT_ALIEN,
  CITIZENSHIP_RESIDENT_ALIEN,
  CITIZENSHIP_US_CITIZEN,
} from './citizenship-status-literals';

// TODO-Personal Info Refactor: remove the OVV data from this state, should only be saved to VGIM state
export interface PersonalDataState {
  birthDate: string;
  citizenship: string;
  firstName: string;
  middleName: string;
  lastName: string;
  tin_private: string;
  contactInfo: {
    primaryEmailAddress: string;
  };
  phoneNumber: string;
  isMobile: boolean;
  loaded: boolean;
  segment: string;
  incapacitated: boolean;
  digitalAdviseService: boolean;
  isOrganizationUser?: boolean;
}

export const initialState: PersonalDataState = {
  birthDate: '',
  citizenship: '',
  firstName: '',
  middleName: '',
  lastName: '',
  tin_private: '',
  contactInfo: {
    primaryEmailAddress: '',
  },
  phoneNumber: '',
  isMobile: false,
  loaded: false,
  segment: '',
  incapacitated: false,
  digitalAdviseService: false,
  isOrganizationUser: false,
};

const personalDataReducer = createReducer(
  initialState,
  on(PersonalDataActions.LoadPersonalDataSuccess, (state) => ({
    ...state,
    loaded: true,
  })),
  on(PersonalDataActions.LoadPersonalDataPayloadSuccess, (state, prop) => ({
    ...state,
    ...prop.payload,
    loaded: true,
  })),
  on(PersonalDataActions.LoadPersonalDataClientFail, (state) => ({
    ...state,
    loaded: false,
  })),

  on(PersonalDataActions.RedirectToPVR, (state) => ({
    ...state,
    loaded: false,
  })),
  on(PersonalDataActions.UpdateClientSegment, (state, prop) => ({
    ...state,
    segment: prop.payload,
  })),
  on(PersonalDataActions.UpdateClientFlagDigitalAdvise, (state, prop) => ({
    ...state,
    digitalAdviseService: prop.payload,
  })),
);

export function reducer(state: PersonalDataState | undefined, action: Action) {
  return personalDataReducer(state, action);
}

export const getLast4IdOnFile = (state: PersonalDataState) => {
  if (state.tin_private.length === 9) {
    return state.tin_private.substring(5);
  }
  return null;
};

export const getClientSegment = (state: PersonalDataState) => state.segment;

export const getClientIncapacitated = (state: PersonalDataState) => state.incapacitated;

export function formatProspectAddressData(state: IDPSResponse) {
  const formatted = {
    streetAddress: {
      ...state.contactInfo.streetAddress,
    },
    mailingAddress: {
      ...state.contactInfo.mailingAddress,
    },
    isStreetAddressSame: state.contactInfo.isStreetSameAsMailing,
  };
  return formatted;
}

export function formatCitizenshipData(citizenship: string) {
  switch (citizenship) {
    case CITIZENSHIP_US_CITIZEN:
    case CitizenshipStatusEnum.UsCitizen:
      return CitizenshipStatusEnum.UsCitizen;
    case CITIZENSHIP_RESIDENT_ALIEN:
    case CitizenshipStatusEnum.ResidentAlien:
      return CitizenshipStatusEnum.ResidentAlien;
    case CITIZENSHIP_NONRESIDENT_ALIEN:
    case CitizenshipStatusEnum.NonresidentAlien:
      return CitizenshipStatusEnum.NonresidentAlien;
    default:
      return CitizenshipStatusEnum.None;
  }
}

// VGIM Personal info state
export const getClientName = (state: MfePersonalInfoClientState['personalInfo']) =>
  [state.firstName, state.middleName, state.lastName].filter(Boolean).join(' ');

export const getClientDateOfBirth = (state: MfePersonalInfoClientState['personalInfo']) =>
  state.birthDate ? state.birthDate : null;

export const getClientEmailAddress = (state: MfePersonalInfoClientState['personalInfo']) =>
  state.email;
